import { flags, useFeatureFlags } from "../lib/feature-flags"

export const usePendingAffiliateBandEnabled = () => {
  const [enabled] =
    useFeatureFlags([flags.FLAG_FEAT_PENDING_AFFILIATE_BAND]) ?? []

  return Boolean(enabled)
}
